export const PATIENT_POINTS_DEFAULT_SORT = {
  sortedColumn: 'fullName',
  sortedColumnOrder: 'ascend'
}
